/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetAlertFrequencyTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAlertFrequencyTypesRequest = createAction<PayloadData<void>>('USER_CONTENT_DICTIONARIES__GET_ALERT_FREQUENCY_TYPES__REQUEST');
export const getAlertFrequencyTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('USER_CONTENT_DICTIONARIES__GET_ALERT_FREQUENCY_TYPES__SUCCESS');
export const getAlertFrequencyTypesFailure = createAction<PayloadData<Error, void, true>>('USER_CONTENT_DICTIONARIES__GET_ALERT_FREQUENCY_TYPES__FAILURE');

export const getAlertFrequencyTypesActions = [
    getAlertFrequencyTypesRequest,
    getAlertFrequencyTypesSuccess,
    getAlertFrequencyTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAlertFrequencyTypes = (config?: GetAlertFrequencyTypes$Config) => {
    return {
        CALL_API: {
            types: getAlertFrequencyTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/alerts/frequency/types`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetLayoutTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLayoutTypesRequest = createAction<PayloadData<void>>('USER_CONTENT_DICTIONARIES__GET_LAYOUT_TYPES__REQUEST');
export const getLayoutTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('USER_CONTENT_DICTIONARIES__GET_LAYOUT_TYPES__SUCCESS');
export const getLayoutTypesFailure = createAction<PayloadData<Error, void, true>>('USER_CONTENT_DICTIONARIES__GET_LAYOUT_TYPES__FAILURE');

export const getLayoutTypesActions = [
    getLayoutTypesRequest,
    getLayoutTypesSuccess,
    getLayoutTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLayoutTypes = (config?: GetLayoutTypes$Config) => {
    return {
        CALL_API: {
            types: getLayoutTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/layouts/types`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSavedListTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedListTypesRequest = createAction<PayloadData<void>>('USER_CONTENT_DICTIONARIES__GET_SAVED_LIST_TYPES__REQUEST');
export const getSavedListTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('USER_CONTENT_DICTIONARIES__GET_SAVED_LIST_TYPES__SUCCESS');
export const getSavedListTypesFailure = createAction<PayloadData<Error, void, true>>('USER_CONTENT_DICTIONARIES__GET_SAVED_LIST_TYPES__FAILURE');

export const getSavedListTypesActions = [
    getSavedListTypesRequest,
    getSavedListTypesSuccess,
    getSavedListTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedListTypes = (config?: GetSavedListTypes$Config) => {
    return {
        CALL_API: {
            types: getSavedListTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/users/saved/list-types`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSavedSearchTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedSearchTypesRequest = createAction<PayloadData<void>>('USER_CONTENT_DICTIONARIES__GET_SAVED_SEARCH_TYPES__REQUEST');
export const getSavedSearchTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('USER_CONTENT_DICTIONARIES__GET_SAVED_SEARCH_TYPES__SUCCESS');
export const getSavedSearchTypesFailure = createAction<PayloadData<Error, void, true>>('USER_CONTENT_DICTIONARIES__GET_SAVED_SEARCH_TYPES__FAILURE');

export const getSavedSearchTypesActions = [
    getSavedSearchTypesRequest,
    getSavedSearchTypesSuccess,
    getSavedSearchTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedSearchTypes = (config?: GetSavedSearchTypes$Config) => {
    return {
        CALL_API: {
            types: getSavedSearchTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/users/saved/search-types`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

